import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/mod_leads'
export default {
  namespaced: true,
  state: {
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      title: null,
      sub_title: null,
      content: null,
      lead_type: null,
      button: null,
      url: null,
      target: '_blank',
      status: null,
      id_users: null,
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    typeList: [
      {
        id: '1',
        title: 'Anasayfa Yüksek Lead',
      },
      {
        id: '2',
        title: 'Anasayfa Basık Lead',
      },
      {
        id: '3',
        title: 'Ürünlerimiz Bilgilendirme Lead',
      },
      {
        id: '4',
        title: 'Anasayfa Yönlendirme Butonu',
      },
    ],
    targetList: [
      {
        id: '_blank',
        title: 'Yeni Sekme',
      },
      {
        id: '_self',
        title: 'Aynı Sekme',
      },
    ],
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
    typeList(state) {
      return state.typeList
    },
    targetList(state) {
      return state.targetList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data.map(item => {
        const type = state.typeList.find(t => t.id === item.lead_type)
        return {
          ...item,
          lead_type_title: type ? type.title : null,
        }
      })
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        title: null,
        sub_title: null,
        content: null,
        lead_type: null,
        button: null,
        status: null,
        id_users: null,
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      commit('RESET_DATA_ITEM')
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
        })
        .catch(error => console.error(error))
    },
    getDataItem({ commit }, id) {
      commit('RESET_DATA_ITEM')
      const data = JSON.stringify({
        where: {
          'mod_leads.id': id,
        },
        array: false,
      })
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_ITEM', response.data.data)
        })
        .catch(error => console.error(error))
    },
    saveData({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    removeData({ commit }, id) {
      axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    resetDataItem({ commit }) {
      commit('RESET_DATA_ITEM')
    },
  },
}
